import React, { Component } from 'react';
import { connect } from "react-redux";
import { Button, Layout } from 'antd';

import Events from "../../services/events";

import PageHeader from '../../components/Modules/PageHeader';
import FilterPanel from "../../components/Modules/FilterPanel";
import Feed from "../Feed";

import PaymentsTab from "../MyProfile/PaymentsTab";
import { auth } from "../../services/firebase/firebase";
import { getUserCard } from "../../services/firebase/user";
import { loadUserDataAction } from "../../actions/userStoreActions";

import './payments.less';

class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      card: null,
    };

    auth().onAuthStateChanged(user => {
      user && this.props.loadUserDataAction(user.uid)
        .then((user) => {
          user && user.card && getUserCard(user.card)
            .then((card) => {
              this.setState({ card: card });
            })
            .catch((err) => console.error('Error get card:', err));
        })
        .catch((err) => console.error('Error initial profile component', err));

      this.setState({ user })
    });
  }

  filterBy(field, value) {
    Events.setFilter(field, value);
    this.setState({refresh: Math.random()})
  }

  render(){
    const { events, user, location } = this.props;
    const { card } = this.state;

    const { userClaims, userData } = user;

    let boughtEvents = [];
    if (userData) {
      boughtEvents = userData.boughtEvents
    }

    let boughtEventsPrepared = [];
    if (events && events.length && boughtEvents ) {
      boughtEvents.forEach((eventId) => {
        const event = events.find((event) => event.id === eventId);
        event && boughtEventsPrepared.push(event)
      });
    }

    return (
      <Layout className="page-wrapper">
        <PageHeader
          title="Purchased Events"
          isHideBackButton={true}
          extra={
            <div className="search-form">
              <FilterPanel filter={this.filterBy} deviceType />
            </div>
          }
          extraMobile={
            <Button type="primary" shape="circle" icon="search" />
          }
          mobileTitleSearch="User search"
          mobileTypeSearch="user"
        />
        <div>
          {
            (userClaims.userType === "Contributor") && (
              <PaymentsTab
                card={card}
                events={events}
                userData={userData}
                user={user}
                location={location}
              />
            )
          }

          <div>
            <h2>Purchased events: </h2>
            {
              boughtEventsPrepared && boughtEventsPrepared.length > 0 ? (
                <Feed
                  list={boughtEventsPrepared}
                  location ={location}
                  renderType={"events"}
                  eventType={"all"}
                  pageType={"list"}
                />
              ) : (
                "You haven't Purchased any events yet."
              )
            }
          </div>
        </div>
      </Layout>
    )
  }
}

export default connect(
  null,
  { loadUserDataAction }
)(Payments);



// WEBPACK FOOTER //
// ./src/pages/Payments/index.js